import { Button, Flex } from "@ir/ui";
import { useNavigate } from "react-router";
import ErrorBoundary from "@src/presentation/components/common/ErrorBoundary";
import type { Organization } from "@src/domain/entities/organization/Organization";

export interface OrganizationCardFooterProps {
  organization: Organization;
}

export const OrganizationCardFooter = ({
  organization,
}: OrganizationCardFooterProps) => {
  const navigate = useNavigate();
  return (
    <ErrorBoundary>
      <Flex align="center" justifyContent="end" style={{ flex: 1 }}>
        <Button
          variant="clear"
          onPress={() =>
            navigate(`/organizations/${organization.organizationKey}`, {
              state: {
                organizationId: organization.organizationId,
                organization,
              },
            })
          }
          htmlTitle="View Organization Details"
        >
          View all
        </Button>
      </Flex>
    </ErrorBoundary>
  );
};
